import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('solutionAttachment', 'solutionAttachments');

const customActions = {
  async LOAD_solutionAttachments({ commit, rootGetters }, solutionId) {
    const data = await odata.o(rootGetters)
      .get('solutionAttachments')
      .query({ $filter: `IsDeleted eq false AND SolutionId eq ${solutionId}` });
    commit('SET_solutionAttachments', data);
    return data;
  },
};

export default { ...actions, ...customActions };
